import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {Rules} from '../models/rules';

export const rulesActionTypes = {
  LOAD: type('[Rules] Load'),
  LOAD_ADVANCE: type('[Rules] Load Contract Id'),
  LOAD_SUCCESS: type('[Rules] Load Success'),
  LOAD_FAIL: type('[Rules] Load Fail'),
  CLEAR: type('[Rules] Clear'),
};

export class LoadRulesAction implements Action {
  readonly type = rulesActionTypes.LOAD;
  constructor(public payload?: string) {}
}
export class LoadRulesContractIDAction implements Action {
  readonly type = rulesActionTypes.LOAD_ADVANCE;
  constructor(public payload?: string) {}
}

export class LoadRulesSuccessAction implements Action {
  readonly type = rulesActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Rules[]) {}
}

export class LoadRulesFailAction implements Action {
  readonly type = rulesActionTypes.LOAD_FAIL;
  constructor(public payload?: number) {}
}

export class RulesClearAction implements Action {
  readonly type = rulesActionTypes.CLEAR;
  constructor() {}
}

